module.exports = __webpack_public_path__ + "img/SE5567606032.b499634b.svg";